import React from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import discoverPremiumImg from './images/discover-premium.png';

const useStyles = makeStyles((theme) => ({
  section: {
    maxWidth: '1314px',
    margin: '80px auto 10px',
    padding: '60px 0px 0',
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      margin: '0 auto 10px',
      padding: '30px 16px 0',
    }
  },
  ctaContainer: {
    background: 'linear-gradient(90deg, #CE949C 0%, #E6B1BD 25%, #FFD0E1 55%, #CE949C 100%)',
    borderRadius: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 60px',
    position: 'relative',
    height: 326,
    maxHeight: 326,
    overflow: 'visible',
    boxSizing: 'border-box',
    [theme.breakpoints.down('md')]: {
      padding: '0 40px',
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      padding: '25px 24px 0',
      textAlign: 'center',
      height: 'auto',
      maxHeight: 'none',
      overflow: 'hidden',
    }
  },
  ctaContent: {
    maxWidth: '800px',
    zIndex: 2,
    padding: '0',
    [theme.breakpoints.down('md')]: {
      maxWidth: '560px',
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      padding: '0 0 20px 0',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    }
  },
  ctaTitle: {
    fontFamily: '"Cormorant Garamond", serif',
    fontSize: '52px',
    fontWeight: 400,
    lineHeight: '52px',
    color: '#111111',
    marginBottom: '28px',
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('md')]: {
      fontSize: '44px',
      lineHeight: '48px',
      whiteSpace: 'normal',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '36px',
      lineHeight: '36px',
      whiteSpace: 'normal',
      marginBottom: '20px',
    }
  },
  ctaSubtitle: {
    fontFamily: '"Roboto", sans-serif',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    color: '#111111',
    marginBottom: '24px',
    opacity: 0.9,
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('md')]: {
      whiteSpace: 'normal',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
      lineHeight: '21px',
      width: '85%',
      whiteSpace: 'normal',
    }
  },
  buttonRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      width: '100%',
      gap: '12px',
    }
  },
  btnMember: {
    height: '48px',
    backgroundColor: '#FD3C84 !important',
    color: '#ffffff',
    padding: '0 28px',
    borderRadius: '6px',
    fontFamily: '"Roboto", sans-serif',
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '100%',
    letterSpacing: '0%',
    textTransform: 'capitalize',
    border: 'none',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    // boxShadow: '0 4px 14px rgba(253, 60, 132, 0.3)',
    transition: 'transform 0.2s, background-color 0.2s',
    [theme.breakpoints.down('sm')]: {
      width: '80%',
      maxWidth: '280px',
      height: '38px',
      fontSize: '16px',
      fontWeight: 600,
      lineHeight: '100%',
      letterSpacing: '0%',
      textTransform: 'capitalize',
      padding: '0 24px',
    },
    '&:hover': {
      transform: 'translateY(-1px)',
      backgroundColor: '#ff4081',
    }
  },
  btnCreator: {
    height: '48px',
    backgroundColor: 'transparent',
    color: '#FE5A97',
    padding: '0 28px',
    borderRadius: '6px',
    fontFamily: '"Roboto", sans-serif',
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '100%',
    letterSpacing: '0%',
    textTransform: 'capitalize',
    border: '1px solid #FE5A97',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'transform 0.2s, background-color 0.2s',
    [theme.breakpoints.down('sm')]: {
      border: '1px solid #FD3C84',
      width: '80%',
      maxWidth: '280px',
      height: '38px',
      fontSize: '16px',
      fontWeight: 600,
      lineHeight: '100%',
      letterSpacing: '0%',
      textTransform: 'capitalize',
      padding: '0 24px',
    },
    '&:hover': {
      transform: 'translateY(-1px)',
      backgroundColor: 'rgba(254, 90, 151, 0.08)',
    }
  },
  ctaImageContainer: {
    position: 'absolute',
    right: '60px',
    bottom: 0,
    height: '406px',
    zIndex: 3,
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'flex-end',
    [theme.breakpoints.down('md')]: {
      right: '20px',
      height: '370px',
    },
    [theme.breakpoints.down('sm')]: {
      position: 'relative',
      right: 0,
      bottom: 0,
      width: '100%',
      height: 'auto',
      justifyContent: 'center',
      marginTop: '16px',
    }
  },
  ctaImage: {
    height: '406px',
    width: 'auto',
    objectFit: 'contain',
    objectPosition: 'bottom right',
    display: 'block',
    verticalAlign: 'bottom',
    [theme.breakpoints.down('md')]: {
      height: '370px',
    },
    [theme.breakpoints.down('sm')]: {
      height: '320px',
      maxWidth: '100%',
      objectPosition: 'bottom center',
    }
  }
}));

export const FineArtJourneyCTASection = () => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <Box className={classes.section}>
      <Box className={classes.ctaContainer}>
        <Box className={classes.ctaContent}>
          <Typography className={classes.ctaTitle}>
            Discover Premium Creativity
          </Typography>
          <Typography className={classes.ctaSubtitle}>
            Whether you're looking to explore fine art glamour or create it, your journey starts here.
          </Typography>

          <Box className={classes.buttonRow}>
            <button
              className={classes.btnMember}
              onClick={() => history.push('/member-onboarding-step')}
            >
              Request Member Access
            </button>
            <button
              className={classes.btnCreator}
              onClick={() => history.push('/apply-as-creator')}
            >
              Apply As Creator
            </button>
          </Box>
        </Box>

        <Box className={classes.ctaImageContainer}>
          <img
            src={discoverPremiumImg}
            alt="Discover Premium Creativity"
            className={classes.ctaImage}
          />
        </Box>
      </Box>
    </Box>
  );
};
